import { Passenger } from './train-order'

/**
 * 火车票退票单类
 */
export default class TrainRefundOrder {
  constructor(order = {}) {
    this.id = order.id //  (string, optional): 退票订单id
    this.appId = order.appId // (string, optional): 审批规则id ,
    this.applyDate = order.applyDate // (string, optional): 申请日期 ,
    this.applyDeptName = order.applyDeptName // (string, optional): 申请部门称 ,
    this.applyUserName = order.applyUserName // (string, optional): 申请人名称 ,
    this.errMsg = this.backDescriptor = order.backDescriptor // (string): 上游返回详细信息 系统消时展示 ,
    this.buyServiceCharge = order.buyServiceCharge // (string, optional): 退票服务费 ,
    this.checkDate = order.checkDate // (string, optional): 复核日期 ,
    this.cuRefundAmount = order.cuRefundAmount // (string, optional): 应退金额 ,
    this.cuRefundPoundage = order.cuRefundPoundage // (string, optional): 应退手续费 ,
    this.cuRefundRate = order.cuRefundRate // (string, optional): 退票费率 ,
    this.fromCityName = order.fromCityName // (string, optional): 出发城市名称 ,
    this.fromDate = order.fromDate // (string, optional): 出发日期 ,
    this.fromStationName = order.fromStationName // (string, optional): 出发站点名称 ,
    this.fromStationCode = order.fromStationCode // (string, optional): 出发站点三字码 ,
    this.fromTime = order.fromTime // (string, optional): 出发时间 ,
    this.fromWeek = order.fromWeek // (string, optional): 出发星期 ,
    this.khwcsj = order.khwcsj // (string, optional): 客户完成时间 ,
    this.orderNo = order.orderNo // (string, optional): 原订单编号 ,
    this.payDate = order.payDate // (string, optional): 退款时间 ,
    this.payMethodName = order.payMethodName // (string, optional): 支付方式名称 ,
    this.paySubjectName = order.paySubjectName // (string, optional): 支付科目名称 ,
    this.refundReasonVip = order.refundReasonVip // (string, optional): 企业退票原因 ,
    this.refundServiceCharge = order.refundServiceCharge // (string, optional): 退服务费 ,
    this.refundStatus = order.refundStatus // (string, optional): 退票状态 ,
    this.refundStatusDesc = order.refundStatusDesc // (string, optional): 退票状态描述 ,
    this.sellServiceCharge = order.sellServiceCharge // (string, optional): 加收服务费 ,
    this.sentDeptName = order.sentDeptName // (string, optional): 送审人所在的部门 ,
    this.sentEmpNo = order.sentEmpNo // (string, optional): 送审人编号/名称 ,
    this.sentTime = order.sentTime // (string, optional): 送审时间 ,
    this.showCancel = order.showCancel // (string, optional): 是否显示取消按钮 1显示 其他不显示 ,
    this.showSendApp = order.showSendApp // (string, optional): 是否显示送审按钮 1显示 其他不显示 ,
    this.supplierName = order.supplierName // (string, optional): 供应商名称 ,
    this.ticketPrice = order.ticketPrice // (string, optional): 票价 ,
    this.toCityName = order.toCityName // (string, optional): 到达城市名称 ,
    this.toDate = order.toDate // (string, optional): 到达日期 ,
    this.toStationName = order.toStationName // (string, optional): 到达站名称 ,
    this.toStationCode = order.toStationCode // (string, optional): 到达站三字码 ,
    this.toTime = order.toTime // (string, optional): 到达时间 ,
    this.trOrderId = order.trOrderId // (string, optional): 原订单id ,
    this.trainCode = order.trainCode // (string, optional): 车次编号 ,
    this.trainNo = order.trainNo // (string, optional): 列车编号 ,
    this.travelTime = order.travelTime // (integer): 运行时长 ,
    this.travelTimeStr = order.travelTimeStr // (string, optional): 运行时长 ,
    this.vipStatus = order.vipStatus // (string, optional): 审批状态
    this.tsTpgzts = order.tsTpgzts // (string, optional): 特殊退票规则提示
    
    this.orderType = $dict.ORDER_TYPE.tr.refund
    this.passenger = new Passenger(order, order)
  }
  
  // 是否是拒单
  get isReject () {
    return this.orderStatus === '7' && this.errMsg
  }
  
  // 支付方式
  get payMethodDesc () {
    if (this.payStatus === '1' && this.paySubjectName) {
      return `已使用${this.paySubjectName}支付`
    } else {
      return ''
    }
  }
  
  // 详细的订单描述
  get refundStatusDescDetail() {
    if (this.showSendApp === '1') {
      return '审批通过即可提交退票，请先操作送审'
    } else {
      return '已提交办理，请稍后刷新查看办理情况'
    }
  }
}